"use client"

import { FileText } from "lucide-react"

import { CopyButton } from "@/components/ui/copy-button"
import { Button } from "@/components/ui/button"

/**
 * Agent-friendly actions shown on each doc page: copy the whole page as
 * Markdown (for pasting into an LLM) and a link to view the raw Markdown.
 * The markdown string is built server-side and passed in so the client never
 * re-fetches it.
 */
export function DocPageActions({
  markdown,
  rawHref,
}: {
  markdown: string
  rawHref: string
}) {
  return (
    <div className="flex items-center gap-1 rounded-md border border-border">
      <CopyButton
        value={markdown}
        successMessage="Copied page as Markdown"
        showText
        text="Copy page"
        successText="Copied"
        variant="ghost"
        size="sm"
        className="h-8 rounded-r-none text-xs text-muted-foreground"
      />
      <div className="h-5 w-px bg-border" />
      <Button
        asChild
        variant="ghost"
        size="sm"
        className="h-8 rounded-l-none px-2 text-xs text-muted-foreground"
        title="View as Markdown"
      >
        <a href={rawHref} target="_blank" rel="noopener noreferrer">
          <FileText className="size-3.5" />
          <span className="sr-only">View as Markdown</span>
        </a>
      </Button>
    </div>
  )
}
